import { useMutation } from "@apollo/client/react"; 
import { Grid } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { GeoPosicionamiento } from '../../../ContratosCreation/components/TabDireccionPaciente/components/GeoPosicionamiento';
import toast from 'react-hot-toast';
import GET_GESTION_ASISTENCIAL_PACIENTE_BY_ID from '../../../../data/graphQL/queries/GestionAsistencial/getGestionAsistencialPacienteById';
import { UPDATE_DATOS_UBICACION_ASISTENCIAL } from '../../../../data/graphQL/mutations/GestionAsistencial/updateDatosUbicacionAsistencial';

export const TabUbicaciones = ({
  allowedWrite,
  ubicacionData,
  evaluacionSelected,
  idPaciente,
  cambioDireccion,
  setCambioDireccion,
  pacienteData
}) => {
  const [formData, setFormData] = useState({
    telefonoUbicacion: ubicacionData.telefonoUbicacion || '',
    observacionesUbicacion: ubicacionData.observacionesUbicacion || ''
  });

  const [guardar] = useMutation(UPDATE_DATOS_UBICACION_ASISTENCIAL, {
    refetchQueries: [GET_GESTION_ASISTENCIAL_PACIENTE_BY_ID],
    variables: {
      idPaciente,
      telefono: formData.telefonoUbicacion,
      observacion: formData.observacionesUbicacion
    }
  });
  //TODO falta la integración total de la mutation. Está puesto esta mutation con el motivo de que rompa al intentar guardar

  const updatedFields = useMemo(() => {
    return structuredClone(fields).
      map((input) => {
        const updatedInput = { ...input };
        switch (input.name) {
          case 'telefonoUbicacion':
            updatedInput.disabled = !!evaluacionSelected.telemedicina;
            break;
          default:
            break;
        }
        if (!allowedWrite) {
          updatedInput.disabled = true;
        }
        return updatedInput;
      });
  }, [evaluacionSelected.telemedicina]);

  useEffect(() => {
    setFormData({
      telefonoUbicacion: ubicacionData.telefonoUbicacion || '',
      observacionesUbicacion: ubicacionData.observacionesUbicacion || ''
    });
  }, [ubicacionData.telefonoUbicacion, ubicacionData.observacionesUbicacion]);

  const handleSubmit = () => {
    toast.promise(
      guardar(), {
      loading: 'Guardando "Ubicaciones"...',
      success: '"Ubicaciones" guardado.',
      error: 'Ocurrió un error al intentar guardar "Ubicaciones".'
    }
    );
  };

  const handleChange = (name, value) => {
    if (name !== 'telefonoUbicacion' && name !== 'observacionesUbicacion') return;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const getValue = useCallback((name) => {
    if (name !== 'telefonoUbicacion' && name !== 'observacionesUbicacion') return ubicacionData[name];
    return formData[name];
  }, [ubicacionData, formData]);

  return (
    <div className='generic-tab-container'>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <div className='button-save-geo-data'>
            {allowedWrite && <CustomButton
              onClick={handleSubmit}
              label='Guardar'
              variant='outlined' />
            }
          </div>
        </Grid>
        {updatedFields
          .filter(input => !input.hidden)
          .map((input, index) =>
            <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}>
              {input.name !== 'geoPosicionamiento' && <RenderInputByTypeMobile
                key={`input-${input.name}-index-${index}`}
                input={input}
                handleChange={handleChange}
                value={getValue(input.name)} />
              }
              {input.name === 'geoPosicionamiento' && <GeoPosicionamiento                
                direccionPaciente={{
                  latitud: ubicacionData?.latitud,
                  longitud: ubicacionData?.longitud,
                  direccion: ubicacionData?.direccion,
                  localidad: ubicacionData?.localidad,
                  provincia: ubicacionData?.provincia,
                  codigoPostal: ubicacionData?.codigoPostal
                }}
                idEvaluacion={evaluacionSelected?.idEvaluacion}
                handleChange={handleChange}
                locationIcon
                cambioDireccion={cambioDireccion}
                setCambioDireccion={setCambioDireccion}
                onlyView={!allowedWrite} />
              }
            </Grid>
          )}
      </Grid>
    </div>);

};

const fields = [
  //row
  {
    displayName: 'Direccion',
    name: 'direccion',
    type: 'string',
    disabled: true,
    col: 3
  },
  {
    displayName: 'Provincia',
    name: 'provincia',
    type: 'string',
    disabled: true,
    col: 3
  },
  {
    displayName: 'Cod postal',
    name: 'codigoPostal',
    type: 'string',
    disabled: true,
    col: 2
  },
  {
    displayName: 'geoPosicionamiento',
    name: 'geoPosicionamiento',
    type: 'geoPosicionamiento',
    col: 4
  },
  //row
  {
    displayName: 'Localidad',
    name: 'localidad',
    type: 'string',
    disabled: true,
    col: 3
  },
  {
    displayName: "Teléfono de Ubicación",
    name: "telefonoUbicacion",
    type: "string",
    disabled: false,
    hidden: true,
    col: 3
  },
  //row
  {
    displayName: "Observación",
    name: "observacionesUbicacion",
    type: "long_string",
    disabled: false,
    col: 12
  }];